import { render, staticRenderFns } from "./SvgView.vue?vue&type=template&id=7f05c04f&scoped=true"
import script from "./SvgView.vue?vue&type=script&lang=js"
export * from "./SvgView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f05c04f",
  null
  
)

export default component.exports